import React, { FC } from 'react';
import { t } from 'i18next';
import { useFormApi } from 'informed';
import { useRepository } from '@context';
import { IDropdownOption } from '@ui-modules/types';
import { emailValidator } from '@common/utils';
import { MultiSteps } from '@common/interfaces';
import { useNonSpammyFieldState } from '@common/hooks';
import { validateWithUser } from '../../../../../utils';
import { TextField } from '../../../../../legacyInputs';
import css from '../styles.module.scss';

let agenciesOptions: IDropdownOption[] = [];

const GuestEmailField: FC = () => {
  const formApi = useFormApi();
  const { value: no_passengers } = useNonSpammyFieldState<boolean>('no_passengers');

  const { agenciesRepository } = useRepository();

  const prefillAgencyBasedOnDomain = async (email: string): Promise<void> => {
    const response = await agenciesRepository.getAgencies({
      domain: email.split('@')[1],
      limit: 80,
    });

    agenciesOptions = response.results.map((agency) => ({
      label: agency.short_name,
      value: agency.uuid,
      isThirdParty: agency.domain === 'fallback-agency.org',
    }));

    formApi.setValue('agenciesOptions', agenciesOptions);
  };

  return (
    <div className={css.field}>
      <TextField
        className={css.input}
        disabled={no_passengers}
        label={t('common.email')}
        multistepName={MultiSteps.MainInfo}
        name="email"
        validate={validateWithUser(emailValidator)}
        data-testid="mobility-planner-edit-form-email"
        onChange={(formValue) => {
          const value = (formValue as any).value as string;

          if (value && typeof emailValidator(value) !== 'string') {
            formApi.setValue('agenciesOptions', '');
            prefillAgencyBasedOnDomain?.(value);
          }
        }}
      />
    </div>
  );
};

export default GuestEmailField;
